import React from 'react'
import { Container } from 'reactstrap'

const Demo = () => {
  return (
    <Container className="text-center">
      <div className="top100 bottom100">
        <h3><i>Coming soon...</i></h3>
      </div>
    </Container>
  )
}

export default Demo
